/** Strings owned by `src/manage/audit/AuditPage.tsx` — the audit trail
 * (§ Beheer). */
export const audit = {
  page: {
    title: 'Audit log',
    scopedLead:
      'You see the allowlisted actions for your own companies; consent answers and identity links are never included.',
    actionFilter: 'Filter by action',
    actionPlaceholder: 'action, e.g. department.visibility.update',
    scopeFilter: 'Filter by scope',
    scopePlaceholder: 'scope id',
    filter: 'Filter',
    empty: 'No audit rows.',
    when: 'When',
    action: 'Action',
    actorRole: 'Actor role',
    target: 'Target',
    rowsLabel: 'the audit rows',
  },
} as const;
